import { render } from "./SpotTest.vue?vue&type=template&id=2c6b0e8c&scoped=true"
import script from "./SpotTest.vue?vue&type=script&lang=js"
export * from "./SpotTest.vue?vue&type=script&lang=js"

import "./SpotTest.vue?vue&type=style&index=0&id=2c6b0e8c&lang=scss&scoped=true"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6b0e8c"]])

export default __exports__